import styled, { css } from 'styled-components'

import { Text } from '@/components/shared-components/BUI/Text'

type WrapperProps = {
  noMargin?: boolean
  shiftUp?: boolean
}

export const DisplayBlockWrapper = styled.div<WrapperProps>`
  padding-top: 0.5rem;
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '1rem')};

  ${({ shiftUp }) =>
    shiftUp &&
    css`
      margin-top: -1.75rem;
    `}
`

export const DisplayName = styled(Text).attrs({
  variant: 'suheading02',
  strong: true,
  mb: '0.25rem',
})`
  margin-bottom: 0.25rem !important;
`

export const DisplayDescription = styled.span`
  ${({ theme }) => theme.font.label02}
  color: ${({ theme }) => theme.colour.secondary._500};
  margin-bottom: 0.5rem;
  display: block;
  white-space: pre-wrap;
`

export const DisplayInfoWrapper = styled.div`
  padding: 0.5rem;
  margin-top: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colour.secondary._50};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  &:empty {
    display: none;
  }
`

export const DisplayAttachmentsWrapper = styled(DisplayInfoWrapper)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
`

export const SmallHeading = styled.span`
  ${({ theme }) => theme.font.caption01}
  color: ${({ theme }) => theme.colour.secondary._400};
`

export const Unanswered = styled(Text).attrs({
  block: true,
  secondary: '_300',
  children: 'Unanswered',
})``
